import Switch2 from '../Switch/Switch'
import { _fields_of_user_data_in_mypage } from '../../localConstant'
import ManagementModule from './ManagementScreen.module.scss'
import LoadingGrid from '../LoadingGrid/LoadingGrid'
import CloseIcon from '@mui/icons-material/Close'
import React from 'react'
function StudentListModal({
  classRoomData,
  isOpen,
  onOpen,
  onClose,
  selectedPrompt,
  handleInputAvailableAllStudentsChange,
  searchFields,
  searchQueries,
  setSearchQueries,
  handleSelectAllStudent,
  handleDeselectAllStudent,
  loadingForStudentData,
  filteredIdsForStudent,
  selectedStudentIds,
  handleStudentCheckboxChange
}) {
  return (
    <>
      <div className={ManagementModule['section-title-group']}>
        <p className={ManagementModule['label']}>生徒単位のモード利用設定</p>
        <button className={ManagementModule['copy']} onClick={onOpen}>
          設定
        </button>
      </div>

      {isOpen && (
        <div
          className={ManagementModule['modal-overlay']}
          style={{
            zIndex: 10,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              onClose()
            }
          }}
        >
          <div className={ManagementModule['modal']} style={{ zIndex: 11 }}>
            <div className={ManagementModule['modal-content']} onClick={(e) => e.stopPropagation()}>
              <CloseIcon className={ManagementModule['close-modal']} onClick={onClose} />
              <h3 className={ManagementModule['section-title-in-modal']}>生徒単位のモード利用設定</h3>
              <p className={ManagementModule['section-explanation']}>
                ※ご自身のスクールとこのモードの利用可能スクールの生徒に対してこのモードが利用できるかどうかを設定します。利用不可の教室の生徒は表示されません。
              </p>
              <div className={ManagementModule['prompt-input3-modal']}>
                <div className={ManagementModule['prompt-input-fields-container4']}>
                  <span className={ManagementModule['sub-field']}>全生徒に対してモードを利用可能にする</span>
                  <Switch2
                    checked={selectedPrompt.availableAllStudents}
                    onChange={() => handleInputAvailableAllStudentsChange(selectedPrompt.availableAllStudents)}
                  />
                </div>
              </div>
              {selectedPrompt.availableAllStudents === false && (
                <>
                  <div className={ManagementModule['search-container']}>
                    {searchFields.map((field, index) => (
                      <React.Fragment key={field.key}>
                        <input
                          className={ManagementModule['search']}
                          type="text"
                          placeholder={field.placeholder}
                          value={searchQueries[field.key]}
                          onChange={(e) =>
                            setSearchQueries({
                              ...searchQueries,
                              [field.key]: e.target.value
                            })
                          }
                        />
                      </React.Fragment>
                    ))}
                    <button className={ManagementModule['rectangle']} onClick={handleSelectAllStudent}>
                      全選択
                    </button>
                    <button className={ManagementModule['rectangle']} onClick={handleDeselectAllStudent}>
                      全解除
                    </button>
                  </div>
                  {loadingForStudentData ? (
                    <LoadingGrid />
                  ) : (
                    <table className={ManagementModule['doc-list-table']}>
                      <thead>
                        <tr>
                          <th>選択</th>
                          <th>学校名</th>
                          <th>教室</th>
                          <th>生徒名</th>
                          <th>生徒ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredIdsForStudent.map((student) => (
                          <tr className={ManagementModule['doc-list-row']} key={student.id}>
                            <td className={ManagementModule['doc-list-cell']}>
                              <Switch2
                                value={student.id}
                                checked={selectedStudentIds.includes(student.id)}
                                onChange={handleStudentCheckboxChange}
                              />
                            </td>
                            <td className={ManagementModule['doc-list-cell']}>{student.schoolName}</td>
                            <td className={ManagementModule['doc-list-cell']}>{student.classRoom}</td>
                            <td className={ManagementModule['doc-list-cell']}>{student.name}</td>
                            <td className={ManagementModule['doc-list-cell']}>{student.loginId}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default StudentListModal
